import { CourierReturnStatusType, OrderStatus, OrderDelayStatus } from './model-enum';

export const Statuses = { ...OrderStatus, ...CourierReturnStatusType, ...OrderDelayStatus } as const;

export const courierStatusTranslationKeys = {
  [Statuses.Assigned]: 'order_courier.statusAssigned',
  [Statuses.InDelivery]: 'order_courier.statusDelivering',
  [Statuses.Delivered]: 'order.status_DELIVERED',
  [Statuses.Unassigned]: 'order.status_UNASSIGNED',
  [Statuses.AssignedToNextPool]: 'order.status_ASSIGNED_TO_NEXT_POOL',
  [Statuses.Returning]: 'Returning',
  [Statuses.Nearby]: 'Returning',
  [Statuses.Arrived]: 'courier.arrivedAtRestaurant',
  [Statuses.Delayed]: 'Delayed delivery',
} as OrderStatus & CourierReturnStatusType;

export const orderCourierStatusTranslationKeys = {
  [Statuses.Assigned]: 'order_courier.statusAssigned',
  [Statuses.InDelivery]: 'order.status_IN_DELIVERY',
  [Statuses.Delivered]: 'order.status_DELIVERED',
  [Statuses.Unassigned]: 'order.status_UNASSIGNED',
  [Statuses.AssignedToNextPool]: 'order.status_ASSIGNED_TO_NEXT_POOL',
  [Statuses.Returning]: 'Returning',
  [Statuses.Nearby]: 'Returning',
  [Statuses.Arrived]: 'courier.arrivedAtRestaurant',

} as OrderStatus & CourierReturnStatusType;

export const ACTIVE_COURIER_SORT_BY_ORDER = {
  [Statuses.Returning]: 1,
  [Statuses.InDelivery]: 2,
  [Statuses.Assigned]: 3,
} as any;

export const SORT_BY_STATUS = {
  [OrderStatus.Delivered]: 4,
  [OrderStatus.InDelivery]: 1,
  [OrderStatus.Assigned]: 2,
  [OrderStatus.AssignedToNextPool]: 5,
  [OrderStatus.Unassigned]: 3
}

export const ACTIVE_COURIER_DETAIL_SORT_BY_STATUS = {
  [OrderStatus.Delivered]: 3,
  [OrderStatus.InDelivery]: 1,
  [OrderStatus.Assigned]: 2,
  [OrderStatus.AssignedToNextPool]: 4,
  [OrderStatus.Unassigned]: 5
}

export const INITIAL_ZOOM_LEVEL = 16;
export const DETAILED_ZOOM_LEVEL = 17;